import { Content } from '@prismicio/client';
import type { Simplify } from '../../../../prismicio-types';
import { CTAImage, CTATextContent } from '.';

import styles from './cTAInner.module.scss';

interface CTAInnerProps {
  data: Simplify<Content.CallToActionSliceDefaultPrimary>;
}

export const CTAInner = ({ data }: CTAInnerProps) => {
  return (
    <div className={styles.inner}>
      <CTATextContent
        title={data.title}
        buttonLink={data.button_link}
        buttonText={data.button_text}
        subtitle={data.subtitle}
      />
      <CTAImage image={data.image} cards={data.cards} />
    </div>
  );
};
